"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getenv = void 0;
function getenv(field) {
    const value = typeof window !== 'undefined' ? window.env[field] : process.env[field];
    if (value === undefined) {
        throw new Error(`Missing env variable [${field}]`);
    }
    return value;
}
exports.getenv = getenv;
if (typeof window !== 'undefined') {
    window.getenv = getenv;
}
